import React from "react";
import year from "../assets/img/year.png";
import AOS from "aos";
import "aos/dist/aos.css";

function Company() {
  return (
    <div className="container mx-auto">
      <div className="flex flex-col gap-40 px-4 pb-52 pt-28 mt-72">
        {/* 2015 */}
        <section className="flex flex-col justify-center w-full">
          <p className="text-3xl font-bold text-gray-800 mb-3">2015</p>
          <div className="w-2 h-10 bg-gray-200"></div>
          <div className="flex items-center justify-center w-10 h-10 bg-gradient1 rounded-full duration-200 hover:scale-150 hover:shadow-lg">
            <p className="text-white text-xl font-bold">05</p>
          </div>
          <div className="w-2 h-10 bg-gray-200"></div>
          <div className="flex items-center justify-center w-10 h-10 bg-gradient1 rounded-full duration-200 hover:scale-150 hover:shadow-lg">
            <p className="text-white text-xl font-bold">12</p>
          </div>
          <div className="w-2 h-10 bg-gray-200"></div>
          <div className="flex items-center justify-center w-10 h-10 bg-gradient1 rounded-full duration-200 hover:scale-150 hover:shadow-lg">
            <p className="text-white text-xl font-bold">+</p>
          </div>
        </section>
        {/* 2015 */}
        <section className="flex flex-col items-center justify-center">
          <p className="text-3xl font-bold text-gray-800 mb-3">2015</p>
          <div className="w-2 h-10 bg-gray-200"></div>
          <div className="flex items-center justify-center w-10 h-10 bg-gradient1 rounded-full duration-200 hover:scale-150 hover:shadow-lg">
            <p className="text-white text-xl font-bold">05</p>
          </div>
          <div className="w-2 h-10 bg-gray-200"></div>
          <div className="flex items-center justify-center w-10 h-10 bg-gradient1 rounded-full duration-200 hover:scale-150 hover:shadow-lg">
            <p className="text-white text-xl font-bold">12</p>
          </div>
          <div className="w-2 h-10 bg-gray-200"></div>
          <div className="flex items-center justify-center w-10 h-10 bg-gradient1 rounded-full duration-200 hover:scale-150 hover:shadow-lg">
            <p className="text-white text-xl font-bold">+</p>
          </div>
        </section>
      </div>
    </div>
  );
}

AOS.init();
export default Company;
